import { admin } from './admin'
import { ajuda } from './ajuda'
import { cadastros } from './cadastros'
import { integracoes } from './integracoes'
import { manutencaoPonto } from './manutencao-ponto'
import { relatorios } from './relatorios'

const paths = [
    admin,
    ajuda,
    cadastros,
    integracoes,
    manutencaoPonto,
    relatorios,
]

export default paths
